
import React from 'react';
import Store from '../../redux/store';
import '../../resources/css/notice-page.css';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Propaganda, RestaurantInfo } from '../../constants/type.constant';
import { getCacheField } from '../../tools/get-cache-field';
import i18nService from '../../i18n';
import { preLoadNginxImage } from '../../tools/utils';

class HeaderBar extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    public scrollHomedivTimeOut!: NodeJS.Timeout;
    public scrollCount = 0;
    constructor(props: Props) {
        super(props);
        this.state = {
            isTouchMove: false,
            touchStartY: 0,
            touchEndY: 0,
            isShowLocale: false,
            qopLogo: ``,
            backGroundImg: ``,
            isLoadImg: true,
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************
    
    public async UNSAFE_componentWillMount() {
        await this.preloadImg();
    }

    public componentDidMount() {
        // 首页向下滑动时,LOGO区域需要自动收缩
        let homeMainTop = document.getElementById('homeMainTop');
        homeMainTop?.addEventListener('scroll', this.homeScrollView);
    }

    public componentWillUnmount() {
        document.removeEventListener('scroll', this.homeScrollView);
        this.setState = (state, callback) => { return; };
    }

    async preloadImg() {
        let logoImg = `${Store.getState().serverUrl}/qop_logo/logo.jpg`;
        let backgroundImg = `${Store.getState().serverUrl}/bulletin/back_ground_image.jpg?${Math.random()}`;
        const newLogoImg = await preLoadNginxImage(logoImg, 'qop_logo', 'qop');
        const newBackgroundImg = await preLoadNginxImage(backgroundImg, '/bulletin', '');
        this.setState({
            qopLogo: newLogoImg,
            backGroundImg: newBackgroundImg,
            isLoadImg: !!newBackgroundImg,
        })
    }

    /**
     * 首页向下滑动时,LOGO区域需要自动收缩
     * 
     */
    public homeScrollView = () => {
        clearTimeout(this.scrollHomedivTimeOut)
        let homeMainTop = document.getElementById('homeMainTop');
        // 性能优化 ,限制100ms内只执行一遍
        // this.scrollHomedivTimeOut = setTimeout(() => {}, 100);
        // console.log(this.scrollCount, 'this.scrollCount');
        if (homeMainTop && homeMainTop.scrollTop >= 200) {
            if (this.state.isTouchMove) return;
            this.setState({ isTouchMove: true })
        }
        if (homeMainTop && homeMainTop.scrollTop < 200) {
            if (!this.state.isTouchMove) return;
            this.setState({ isTouchMove: false })
        }
    }

    // public shouldComponentUpdate(nextProp: any, nextState: State) {
    //     return false
    // }

    // *********************
    // 方法区
    // *********************

    // *********************
    // 视图区
    // *********************

    render() {
        const { isTouchMove, isShowLocale, isLoadImg } = this.state;
        const { restaurantInfo } = this.props;
        return (
            <React.Fragment>
                <div className="homePage-header">
                    {/* // 收缩 */}
                    <div className="change-header" style={{ opacity: isTouchMove ? 1 : 0 }}>
                        <div className="shrink-box">
                            {/* 餐馆logo区域 */}
                            <div className='restaurantLogo'>
                                {
                                    this.state.qopLogo &&
                                    <img src={this.state.qopLogo} alt="logo" />
                                }
                            </div>
                            <div className="Jumplink-box">
                                {/* 宣传资料--跳转链接 */}
                                {/* <div className="Jumplink">
                                    <Button
                                        style={{ display: 'flex', flex: 1 }}
                                        onClick={() => {
                                            const propagandaRes = propagandaData.find(item => item.name === 'RESERVATION');
                                            if (propagandaRes) window.open(`${propagandaRes.url}`);
                                        }}
                                    >
                                        <div className="Jumplink-bottom">
                                            <AccessTimeIcon />
                                        </div>

                                    </Button>
                                    <Button
                                        style={{ display: 'flex', flex: 1 }}
                                        onClick={() => {
                                            const propagandaRes = propagandaData.find(item => item.name === 'TAKEAWAY');
                                            if (propagandaRes) window.open(`${propagandaRes.url}`);
                                        }}
                                    >
                                        <div className="Jumplink-bottom">
                                            <DirectionsBikeIcon />
                                        </div>

                                    </Button>
                                </div> */}
                                <div className="select-locale" onClick={() => this.setState({ isShowLocale: !isShowLocale })}>
                                    {
                                        isShowLocale &&
                                        <LocaleSelect changeState={() => {
                                            this.setState({ isShowLocale: false })
                                        }} />
                                    }
                                    <div>{getCacheField('language')}</div>
                                    <ArrowDropDownIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* // 展开 */}
                    <div className="normal-header" style={{ backgroundImage: `url(${this.state.backGroundImg})` }}>
                        <div className="area-box" style={{ backgroundColor: isLoadImg ? ' rgba(12, 25, 68, 0.6)' : '#666b9e' }}>
                            <div
                                className="select-locale"
                                onClick={() => this.setState({ isShowLocale: !isShowLocale })}
                            >
                                {
                                    isShowLocale &&
                                    <LocaleSelect changeState={() => {
                                        this.setState({ isShowLocale: false })
                                    }} />
                                }
                                <div>{getCacheField('language')}</div>
                                <ArrowDropDownIcon />
                            </div>
                            {/* 餐馆logo区域 */}

                            {
                                this.state.qopLogo &&
                                <div className='restaurantLogo'>
                                    <img src={this.state.qopLogo} alt="logo" />
                                </div>
                            }
                            <div className="customer-name">
                                <p style={{ margin: 0 }}> {restaurantInfo.restaurant_name}</p>
                            </div>
                        </div>
                        {/* 宣传资料--跳转链接 */}
                        {/* <div className="Jumplink">
                            <Button
                                style={{ display: 'flex', flex: 1 }}
                                onClick={() => {
                                    const propagandaRes = propagandaData.find(item => item.name === 'RESERVATION');
                                    if (propagandaRes) window.open(`${propagandaRes.url}`);
                                }}
                            >
                                <div className="Jumplink-bottom">
                                    <AccessTimeIcon />
                                    <div>{i18n.t('auto_open_page_text_reservation')}</div>
                                </div>

                            </Button>
                            <div style={{ width: '1px', background: '#797979', margin: '1vh 0' }} />
                            <Button
                                style={{ display: 'flex', flex: 1 }}
                                onClick={() => {
                                    const propagandaRes = propagandaData.find(item => item.name === 'TAKEAWAY');
                                    if (propagandaRes) window.open(`${propagandaRes.url}`);
                                }}
                            >
                                <div className="Jumplink-bottom">
                                    <DirectionsBikeIcon />
                                    <div>{i18n.t('auto_open_page_text_takeaway')}</div>
                                </div>

                            </Button>
                        </div> */}
                    </div>

                </div>
            </React.Fragment >
        )
    }

}
export default withSnackbar(HeaderBar);

// **********
// TYPE
// **********

type Props = {
    // 宣传资料数据
    propagandaData: Array<Propaganda>;
    // 餐馆信息
    restaurantInfo: RestaurantInfo;
} & WithSnackbarProps

type State = {

    isTouchMove: boolean;
    // 上下滑动数值
    touchStartY: number;
    touchEndY: number;
    isShowLocale: boolean;
    // LOGO
    qopLogo: string;
    // 餐馆自定义背景图
    backGroundImg: string;
    // 是否成功加载背景图
    isLoadImg: boolean;
}


function LocaleSelect(props: {
    changeState: () => void;
}) {
    const localeList = ['EN', 'IT', 'ZH', 'ES', 'DE', 'PT'];
    return (

        <div style={{ position: 'absolute', top: 0, right: 0, padding: 8, width: '100%' }}>
            {
                <div className="locale-fixed">
                    {
                        localeList.map((val, index) => {
                            return (
                                <div
                                    key={`local-list-${index}`}
                                    onClick={() => {
                                        props.changeState();
                                        i18nService.changeLanguage(val);
                                        Store.dispatch({
                                            type: 'SET_CACHING',
                                            path: 'language',
                                            value: val
                                        });
                                    }}
                                    style={
                                        getCacheField('language') === val ? {
                                            justifyContent: 'center',
                                            backgroundColor: '#273455'
                                        } : {
                                            justifyContent: 'center',
                                        }
                                    }
                                >
                                    <div
                                        style={{
                                            color: '#fff', textAlign: 'center', lineHeight: '30px',
                                            opacity: getCacheField('language') === val ? 1 : 0.26
                                        }}
                                    >
                                        {val}
                                    </div>

                                </div>
                            )
                        })
                    }
                </div>
            }
        </div >
    )
}